export const toBase64 = (file: FileList[0] | Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader: any = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = (error: any) => reject(error)
  })
